// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_WATCHDOG_SUBSCRIBE = "ulo\u017een\u00ed hled\u00e1n\u00ed";
export const BAZAAR_WATCHDOG_CANCELED = "Ulo\u017een\u00e9 hled\u00e1n\u00ed bylo zru\u0161en\u00e9.";
export const BAZAAR_WATCHDOG_SAVED = "Hled\u00e1n\u00ed bylo \u00fasp\u011b\u0161n\u011b ulo\u017eeno.";
export const PAGE_SLUG = "strana";
